import Icon from '@/components/FpsIcon/index.vue'
import Img from '@/components/FpsImg/index.vue'
import ScaleImg from '@/components/FpsImg/scale.vue'
import Avatar from '@/components/FpsAvatar/index.vue'
import Switch from '@/components/FpsSwitch/index.vue'
import Voice from '@/components/FpsVoice/index.vue'
import FpsStar from '@/components/FpsStar'
import Checkbox from '@/components/FpsCheckbox'

export default {
  install (Vue) {
    Vue.component('fps-icon', Icon)
    Vue.component('fps-img', Img)
    Vue.component('fps-scale-img', ScaleImg)
    Vue.component('fps-avatar', Avatar)
    Vue.component('fps-switch', Switch)
    Vue.component('fps-voice', Voice)
    Vue.component('fps-star', FpsStar)
    Vue.component('fps-checkbox', Checkbox)
  },
}
